export const SHOW_LOGIN_NOTICE_KEY = 'show_login_notice'
export const SHOW_LOGIN_NOTICE_USER_ID_KEY = 'show_login_notice_user_id'
export const SHOW_LOGIN_NOTICE_DISMISSED_USER_ID_KEY =
  'account_sharing_login_notice_dismissed_user_id'
export const ACCOUNT_SHARING_LOGIN_NOTICE_CTA_HASH =
  '#account-sharing-login-notice-talk-to-us'
export const ACCOUNT_SHARING_LOGIN_NOTICE_BANNER_SELECTOR =
  '[data-uf-content="banner"]'
export const USETIFUL_OPEN_URL_ACTION_SELECTOR =
  '[data-action="openURL"], [data-action="goto"], a[href]'
export const USETIFUL_CLOSE_BUTTON_SELECTOR = 'button[data-action="close"]'

function hasWindowStorage(storageKey) {
  return process.client && typeof window !== 'undefined' && window[storageKey]
}

function getLocalStorage() {
  return hasWindowStorage('localStorage') ? window.localStorage : null
}

function stringifyUserId(userId) {
  return userId === undefined || userId === null ? '' : String(userId)
}

export function getUserId(user) {
  return user && (user.id || user.clientId)
}

export function setLoginNoticeForUser(userId) {
  const storage = getLocalStorage()
  const userIdString = stringifyUserId(userId)

  if (!storage || !userIdString) return false

  const changed =
    storage.getItem(SHOW_LOGIN_NOTICE_KEY) !== 'true' ||
    storage.getItem(SHOW_LOGIN_NOTICE_USER_ID_KEY) !== userIdString

  storage.setItem(SHOW_LOGIN_NOTICE_KEY, 'true')
  storage.setItem(SHOW_LOGIN_NOTICE_USER_ID_KEY, userIdString)

  return changed
}

export function clearLoginNotice() {
  const storage = getLocalStorage()

  if (!storage) return false

  const changed =
    storage.getItem(SHOW_LOGIN_NOTICE_KEY) !== null ||
    storage.getItem(SHOW_LOGIN_NOTICE_USER_ID_KEY) !== null

  storage.removeItem(SHOW_LOGIN_NOTICE_KEY)
  storage.removeItem(SHOW_LOGIN_NOTICE_USER_ID_KEY)

  return changed
}

export function clearLoginNoticeForDifferentUser(userId) {
  const storage = getLocalStorage()
  const userIdString = stringifyUserId(userId)

  if (!storage || !userIdString) return false

  const hasLoginNotice = storage.getItem(SHOW_LOGIN_NOTICE_KEY) === 'true'
  const storedUserId = storage.getItem(SHOW_LOGIN_NOTICE_USER_ID_KEY)
  if (hasLoginNotice && storedUserId !== userIdString) {
    return clearLoginNotice()
  }

  return false
}

export function clearLoginNoticeDismissal() {
  const storage = getLocalStorage()

  if (!storage) return false

  const changed =
    storage.getItem(SHOW_LOGIN_NOTICE_DISMISSED_USER_ID_KEY) !== null
  storage.removeItem(SHOW_LOGIN_NOTICE_DISMISSED_USER_ID_KEY)

  return changed
}

export function isLoginNoticeDismissedForUser(userId) {
  const storage = getLocalStorage()
  const userIdString = stringifyUserId(userId)

  if (!storage || !userIdString) return false

  return (
    storage.getItem(SHOW_LOGIN_NOTICE_DISMISSED_USER_ID_KEY) === userIdString
  )
}

export function dismissLoginNotice(userId) {
  const storage = getLocalStorage()
  const userIdString = stringifyUserId(userId)
  let changed = clearLoginNotice()

  if (!storage || !userIdString) return changed

  const dismissalChanged =
    storage.getItem(SHOW_LOGIN_NOTICE_DISMISSED_USER_ID_KEY) !== userIdString

  storage.setItem(SHOW_LOGIN_NOTICE_DISMISSED_USER_ID_KEY, userIdString)

  return changed || dismissalChanged
}

export function containsAccountSharingCtaMarker(value) {
  if (typeof value !== 'string') return false
  if (value === ACCOUNT_SHARING_LOGIN_NOTICE_CTA_HASH) return true

  try {
    const base =
      typeof window !== 'undefined' && window.location
        ? window.location.href
        : 'https://app.importgenius.com/'
    return new URL(value, base).hash === ACCOUNT_SHARING_LOGIN_NOTICE_CTA_HASH
  } catch (error) {
    return false
  }
}
